import axios from 'axios';
import environment from '../config/appConfig';

const apiClient = axios.create({
  baseURL: environment.paymentApiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;
